import _ from '@lodash';
import AspectService from './AspectService';
import AspectEditService from './AspectEditService';

class StorageAspectService {
	constructor() {
		this.outputKeysResult = [];
		this.inputAttributeResult = [];
		this.outputAttributeResult = [];
	}

	getOutputKeysSelection(id) {
		if (_.isUndefined(this.outputKeysResult[id]))
			return new Promise((resolve, reject) => {
				AspectService.getOutputKeysSelection(id).then(resp => {
					this.outputKeysResult[id] = resp;
					resolve(resp);
				}).catch(e => reject(e));
			});
		return new Promise(resolve => {
			resolve(this.outputKeysResult[id]);
		});
	}

	getInputAttributesListSelection(id) {
		if (_.isUndefined(this.inputAttributeResult[id]))
			return new Promise((resolve, reject) => {
				AspectService.getInputAttributesListSelection(id).then(resp => {
					this.inputAttributeResult[id] = resp;
					resolve(resp);
				}).catch(e => reject(e));
			});
		return new Promise(resolve => {
			resolve(this.inputAttributeResult[id]);
		});
	}

	getOutputAttributesListSelection(id) {
		if (_.isUndefined(this.outputAttributeResult[id]))
			return new Promise((resolve, reject) => {
				AspectEditService.getData(id).then(resp => {
					const list = _.uniqBy((resp?.outputAttributes || []).filter(a => a && a.name).map(a => ({ label: a.name, value: a.name, isDefault: false })), 'value');
					this.outputAttributeResult[id] = list;
					resolve(list);
				}).catch(e => reject(e));
			});
		return Promise.resolve(this.outputAttributeResult[id]);
	}
}

export default StorageAspectService;